import { z } from "zod";

export const ApiErrorSchema = z.object({
  Code: z.number(),
  HttpCode: z.number(),
  ErrorCode: z.number(),
  StatusCode: z.number(),
  Message: z.string(),
  StackTrace: z.string().nullish(),
});

export type TApiError = z.infer<typeof ApiErrorSchema>;

export const ApiDefaultSchema = z.object({
  Error: ApiErrorSchema.nullish(),
  IsSuccess: z.boolean().nullish(),
  Trace: z.string().nullish(),
  AutoConfigGitHash: z.string().nullish(),
  Data: z.any().nullish(),
  Version: z.string().nullish(),
});

export type TApiDefault = z.infer<typeof ApiDefaultSchema>;
